import { InjectionToken } from '@angular/core';
import { SearchService } from '../../../../shared/services/search.service';

export const ActiveLocationsSearchService = new InjectionToken<SearchService>('ActiveLocationsSearchService');
